import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import CountrySwitcher from '@/shared/components/UI/CountrySwitcher.vue';

import { queryCountryConfigs } from '../graphql/gateway/queries';
import { apolloClientInit } from '../utils/apollo-client';

export const initCountrySwitcher = async () => {
  if (window.location.pathname.startsWith('/cart')) {
    return;
  }

  const mountSelector = '#footer-country-switcher';
  const mountElement = document.querySelector<HTMLDivElement>(mountSelector);

  if (!mountElement) {
    console.error(`Element with id: "${mountSelector}" not found.`);
    return;
  }

  const cartCurrency = mountElement.dataset.cartCurrency;

  try {
    const graphqlHost = import.meta.env.VITE_HOBBII_GATEWAY;
    const apolloClient = apolloClientInit({ graphqlHost });

    const countryDataResponse = await apolloClient.query(queryCountryConfigs());

    if (countryDataResponse.data) {
      await mountCoreVueApp(
        CountrySwitcher,
        mountSelector,
        {
          countryConfigs: countryDataResponse.data.countryConfigs ?? [],
          cartCurrency
        },
        null,
        { noClients: true }
      );
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // some old browsers are incompatible with queueMicrotask, used internally by query()
    // In this case the user will not be able to switch country.
  }
};
